import { render, staticRenderFns } from "./CrearDescargaActividadModal.vue?vue&type=template&id=d0770774&"
import script from "./CrearDescargaActividadModal.vue?vue&type=script&lang=ts&"
export * from "./CrearDescargaActividadModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports